const env = process.env.NODE_ENV
const firebaseConfig = {
  apiKey: '',
  authDomain: '',
  databaseURL: '',
  projectId: '',
  storageBucket: '',
  messagingSenderId: '',
  storageBucketConvertMP3: ''
}
switch (env) {
  case 'dev':
    firebaseConfig.apiKey = 'AIzaSyAoFth_ai13RL7qK5J2AlnlSrD876cRCGQ'
    firebaseConfig.authDomain = 'vrcam-dev-5a815.firebaseapp.com'
    firebaseConfig.databaseURL = 'https://vrcam-dev-5a815.firebaseio.com'
    firebaseConfig.projectId = 'vrcam-dev-5a815'
    firebaseConfig.newStorageBucket = 'vrmaker-dev'
    firebaseConfig.storageBucket = 'vrcam-dev-5a815.appspot.com'
    firebaseConfig.messagingSenderId = '798666529342'
    firebaseConfig.storageBucketConvertMP3 = 'webmtomp3dev'
    break
  case 'test':
    firebaseConfig.apiKey = 'AIzaSyDfNWcSyYhztNlHNHkxPA1WR9KREgSDqHE'
    firebaseConfig.authDomain = 'vrcam-test.firebaseapp.com'
    firebaseConfig.databaseURL = 'https://vrcam-test.firebaseio.com'
    firebaseConfig.projectId = 'vrcam-test'
    firebaseConfig.newStorageBucket = 'vrcam-test-images'
    firebaseConfig.storageBucket = 'vrcam-test.appspot.com'
    firebaseConfig.messagingSenderId = '642936130505'
    firebaseConfig.storageBucketConvertMP3 = 'webmtomp3test'
    break
  case 'prod':
    firebaseConfig.apiKey = 'AIzaSyAfk-fFLo11rMrr7RQrCrLskC03kMwFKhM'
    firebaseConfig.authDomain = 'vr-cam-161603.firebaseapp.com'
    firebaseConfig.databaseURL = 'https://vr-cam-161603.firebaseio.com'
    firebaseConfig.projectId = 'vr-cam-161603'
    firebaseConfig.newStorageBucket = 'vrmaker'
    firebaseConfig.storageBucket = 'vr-cam-161603.appspot.com'
    firebaseConfig.messagingSenderId = '585720971331'
    firebaseConfig.storageBucketConvertMP3 = 'webmtomp3prod'
    break
  default:
}

export default firebaseConfig
